/**
 * 绑定状态
 */
export default function bindStatus(val) {
    let str = '';
    switch (val) {
    case 0:
        str = '未绑定';
        break;
    case 1:
        str = '已绑定';
        break;
    case 2:
        str = '已解绑';
        break;
    default:
        break;
    }
    return str;
}
